import type { FC } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import type { ContractPaymentLineRow } from "@/admin/entities/contractPayments";
import { formatMoney } from "./billingFormat";
import { CONTRACT_ITEM_TYPE_LABEL } from "./billingLabels";

interface ContractPaymentLinesProps {
  lines: ContractPaymentLineRow[];
}

/** Строки платежа со ссылкой на отчёт у строки доли с продаж (спека §5). */
export const ContractPaymentLines: FC<ContractPaymentLinesProps> = ({
  lines,
}) => {
  if (lines.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        Строк нет
      </Typography>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Услуга</TableCell>
          <TableCell>Название</TableCell>
          <TableCell align="right">Сумма</TableCell>
          <TableCell align="right">В валюте организации</TableCell>
          <TableCell>Отчёт</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {lines.map((line, index) => (
          <TableRow key={`${line.itemType}-${index}`}>
            <TableCell>
              {CONTRACT_ITEM_TYPE_LABEL[line.itemType] ?? line.itemType}
            </TableCell>
            <TableCell>{line.title}</TableCell>
            <TableCell align="right">{formatMoney(line.amount)}</TableCell>
            <TableCell align="right">
              {formatMoney(line.amountInOrganizationCurrency)}
            </TableCell>
            <TableCell>{line.report?.period ?? ""}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
